<template>
    <div>
        <password class="password" readonly="true" :name="name" :placeholder="placeholder" :show-secret="showSecret" v-model="value" @toggleSecret="$emit('toggleSecret')"/>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import Password from './password';

export default {
    components: {Password},
    name: 'displaySecret',
    mixins: [
        Default,
        Password
    ],
    props: ['name', 'placeholder', 'showSecret', 'value'],
    data() {
        return {
            newValue: ''
        };
    },
    created() {
        this.newValue = this.value;
    },
    watch: {
        value: function(newVal, oldVal) {
            if (newVal !== oldVal)
                this.newValue = newVal;
        },
        newValue: function(newVal, oldVal) {
            this.$emit('input', newVal);
        }
    }
};
</script>

<style lang="scss" scoped>

</style>